import { useEffect, useState } from 'react';
import styles from './page.module.css';
import Card from "../../components/Card/Card";
import SportModul from "../../components/SportModul/SportModul";
import { fetchModulesByCategory } from '../../../code/SportModuleLoader';
import HeroBanner from '../../components/HeroBanner/HeroBanner';

function Gesundheitssport() {
    const [module, setModule] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasImages, setHasImages] = useState(false);


    useEffect(() => {
        setLoading(true);
        fetchModulesByCategory('praevention', setModule);
        setLoading(false);
    }, []);

    if (loading) {
        return (<div></div>)
    }
    return (
        <div>
            <HeroBanner category="praevention" onImagesLoaded={setHasImages} />
            <section className={styles.container} style={{ marginTop: hasImages ? '20px' : 'var(--marginTopDefault)' }}>
                <h1>Prävention</h1>
                <div className={styles.startText}>
                    <p>Ist das letzte Training schon etwas länger her oder möchtest du mit einem gesundheitsorientierten Training zu einem bestimmten Thema beginnen. Wir bieten dir eine feste Kursstruktur mit definierten Schwerpunkten, um Krankheiten vorzubeugen oder auch das Wohlbefinden zu steigern. Unsere zertifizierten Präventionskurse lassen dich unter spezialisierter und professioneller Anleitung trainieren und motivieren. Jetzt vorbeugen und dabei sein. Erlebe wie viel Spaß Prävention machen kann und steigere aktiv deine Lebensqualität – deine Gruppe freut sich schon auf dich!</p>
                    <div className={styles.chapter}>
                        <p className={styles.underline}>Zertifizierung und Qualität</p>
                        <p>Diese Kurse sind nach §20 SGB V zertifiziert. Die Teilnahmegebühr wird bis zu 100% von den gesetzlichen Krankenkassen erstattet.</p>
                    </div>
                    <div className={styles.chapter}>
                        <p className={styles.underline}>Deine Vorteile:</p>
                        <ul className=''>
                            <li>8-10 feste Termine – immer ein Platz für dich frei!</li>
                            <li>Von den Krankenkassen bezuschusst (bis zu 100 %)</li>
                            <li>Kleine, persönliche Gruppen</li>
                            <li>individuelle Korrektur und enger Kontakt zum Trainer</li>
                        </ul>
                    </div>
                    <div className={styles.chapter}>
                        <p className={styles.underline}>Kontakt & Beratung</p>
                        <p>Hast du Fragen oder brauchst du eine persönliche Beratung?<br />Wir beraten gerne telefonisch oder persönlich im Verein: <a href='/unser-verein/tus-05-organisation#geschaeftsstelle'>Unsere Kontaktinformationen</a></p>
                    </div>
                </div>

                <section>
                    <div className={styles.modulesContainer} >
                        {/* --- ALL cards come from the array -------------------------------- */}
                        {module.map((modul, index) => (
                            <Card
                                key={index}
                                id={modul.anchor_id}
                                icon={`${process.env.PUBLIC_URL}${modul.iconPath || modul.icon_path}`}
                                iconText={modul.iconText}
                                title={modul.title}
                                rightText={modul.class || ''}
                            >
                                <SportModul modul={modul} />
                            </Card>
                        ))}
                    </div>
                </section>
            </section>
        </div>
    )
}

export default Gesundheitssport;